<template>
  <div>
    <v-container>
      <v-layout row>
        <v-flex xs4>
          <v-btn @click="back" text class="text_btn">
            <v-icon>keyboard_arrow_left</v-icon>back
          </v-btn>
        </v-flex>
        <v-flex xs8 style="text-align: right">
          <v-btn @click="goToDataExplorer" text class="text_btn" color="primary">
            <v-icon left>poll</v-icon>Data explorer
          </v-btn>
          <v-btn @click="d_edit = true" text class="text_btn">
            <v-icon left>settings</v-icon>Settings
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container>
      <h1>
        <v-icon style="padding-bottom: 5px">storage</v-icon>
        {{ p_name }} / {{ b_name }}
        <span class="grey--text" style="font-size: 15px">({{ b_id }})</span>
      </h1>

      <v-layout row wrap style="margin-top: 20px;" v-if="l_insights">
        <v-flex xs12 sm3 style="padding: 10px;">
          <v-card class="elevation-2 text-center" style="padding: 20px;">
            <div class="grey--text text-uppercase mb-2" style="font-size: 12px; font-weight: bold;">Total Containers</div>
            <h2 class="primary--text" style="font-size: 32px; margin: 0;">{{ getBucketTotalInsights().containers }}</h2>
          </v-card>
        </v-flex>
        <v-flex xs12 sm3 style="padding: 10px;">
          <v-card class="elevation-2 text-center" style="padding: 20px;">
            <div class="grey--text text-uppercase mb-2" style="font-size: 12px; font-weight: bold;">Total Datasets</div>
            <h2 class="primary--text" style="font-size: 32px; margin: 0;">{{ getBucketTotalInsights().datasets }}</h2>
          </v-card>
        </v-flex>
        <v-flex xs12 sm3 style="padding: 10px;">
          <v-card class="elevation-2 text-center" style="padding: 20px;">
            <div class="grey--text text-uppercase mb-2" style="font-size: 12px; font-weight: bold;">Total Rows</div>
            <h2 class="primary--text" style="font-size: 32px; margin: 0;">{{ getBucketTotalInsights().rows }}</h2>
          </v-card>
        </v-flex>
        <v-flex xs12 sm3 style="padding: 10px;">
          <v-card class="elevation-2 text-center" style="padding: 20px;">
            <div class="grey--text text-uppercase mb-2" style="font-size: 12px; font-weight: bold;">Total Storage</div>
            <h2 class="primary--text" style="font-size: 32px; margin: 0;">{{ formatBytes(getBucketTotalInsights().bytes) }}</h2>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap style="margin-top: 20px;" v-else>
        <v-flex xs12 sm3 style="padding: 10px;" v-for="i in 4" :key="i">
          <v-card class="elevation-2 text-center" style="padding: 20px;">
            <v-skeleton-loader type="heading" class="mx-auto mb-2" width="50%"></v-skeleton-loader>
            <v-skeleton-loader type="text" class="mx-auto" width="30%"></v-skeleton-loader>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 style="margin-top: 40px">
          <v-layout row align-center style="margin-bottom: 10px; padding: 0 10px;">
            <h2>Containers</h2>
            <v-spacer></v-spacer>
            <v-btn text class="text_btn" color="primary" @click="d_add_container = true">
              <v-icon left>add</v-icon> Add Container
            </v-btn>
          </v-layout>

          <v-expansion-panels v-if="l_treeview_finished && b_containers.length > 0">
            <v-expansion-panel v-for="container in b_containers" :key="container.id">
              <v-expansion-panel-header>
                <div>
                  <strong>{{ container.name }}</strong>
                  <span class="grey--text" style="font-size: 12px; margin-left: 8px;">({{ container.id }})</span>
                  <span v-if="!l_insights" class="grey--text" style="font-size: 12px; margin-left: 15px;">
                     - Loading insights...
                  </span>
                  <span v-else class="grey--text" style="font-size: 12px; margin-left: 15px;">
                     - {{ getContainerInsights(container.id).datasets }} datasets, {{ getContainerInsights(container.id).rows }} rows ({{ formatBytes(getContainerInsights(container.id).bytes) }})
                  </span>
                </div>
                <template v-slot:actions>
                  <v-icon @click.stop="openContainer(container)" style="margin-right: 15px;">settings</v-icon>
                  <v-icon>$expand</v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Name</th>
                        <th class="text-left">Pattern</th>
                        <th class="text-left">Required</th>
                        <th class="text-right">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="column in container.children" :key="column.id">
                        <td>
                          {{ column.name }}
                          <span class="grey--text" style="font-size: 10px;">({{ column.id }})</span>
                        </td>
                        <td>
                          <span :style="translatePattern(column.pattern).translated ? 'font-style: italic;' : ''">
                            {{ translatePattern(column.pattern).text }}
                          </span>
                        </td>
                        <td>
                          <v-icon small :color="column.required ? 'success' : 'grey'">
                            {{ column.required ? 'check_circle' : 'cancel' }}
                          </v-icon>
                        </td>
                        <td class="text-right">
                          <v-btn icon small @click="openColumn(container, column)">
                            <v-icon small>edit</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                      <tr v-if="container.children.length === 0">
                        <td colspan="4" class="text-center grey--text" style="font-style: italic;">
                          No columns defined for this container.
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <div style="margin-top: 15px; text-align: right;">
                  <v-btn small text color="primary" @click="d_add_column = true; f_new_column_container = container.id; f_new_column_container_name = container.name">
                    <v-icon left small>add</v-icon> Add Column
                  </v-btn>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          
          <div v-else-if="l_treeview_finished && b_containers.length === 0" class="grey--text" style="padding: 20px; text-align: center;">
            No containers found. Create your first one to get started.
          </div>
          
          <Loading v-if="!l_treeview_finished" />
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Dialog for editing buckets -->
    <v-dialog v-model="d_edit" width="500">
      <v-card>
        <v-form @submit="saveEdit">
          <v-card-title class="headline" primary-title
            >Bucket settings</v-card-title
          >

          <v-card-text>
            <v-text-field v-model="f_name" label="Name" />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              text
              class="text_btn"
              @click="d_delete = true"
              type="button"
              >Delete</v-btn
            >
            <v-btn
              color="primary"
              text
              class="text_btn"
              type="submit"
              :loading="l_edit_save"
              >Save</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Confirm dialog when trying to delete a bucket -->
    <v-dialog v-model="d_delete" width="500">
      <v-card>
        <v-form>
          <v-card-title class="headline" primary-title
            >Delete bucket</v-card-title
          >

          <v-card-text>
            <p>
              You are about to delete this bucket (with all the data like
              datasets, etc.). Do you really want to continue? This process
              cannot be undone.
            </p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              text
              class="text_btn"
              @click="d_delete = false"
              type="button"
              >Cancel</v-btn
            >
            <v-btn
              color="red"
              text
              class="text_btn"
              @click="deleteBucket"
              type="button"
              >Delete</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Confirm dialog when trying to delete a container -->
    <v-dialog v-model="d_delete_container" width="500">
      <v-card>
        <v-form>
          <v-card-title class="headline" primary-title
            >Delete container</v-card-title
          >

          <v-card-text>
            <p>
              You are about to delete this container (with all the data inside).
              Do you really want to continue? This process cannot be undone.
            </p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              text
              class="text_btn"
              @click="d_delete_container = false"
              type="button"
              >Cancel</v-btn
            >
            <v-btn
              color="red"
              text
              class="text_btn"
              @click="deleteContainer"
              type="button"
              >Delete</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Confirm dialog when trying to delete a column -->
    <v-dialog v-model="d_delete_column" width="500">
      <v-card>
        <v-form>
          <v-card-title class="headline" primary-title
            >Delete column</v-card-title
          >

          <v-card-text>
            <p>
              You are about to delete this column (with all the data associated
              with this column). Do you really want to continue? This process
              cannot be undone.
            </p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              text
              class="text_btn"
              @click="d_delete_column = false"
              type="button"
              >Cancel</v-btn
            >
            <v-btn
              color="red"
              text
              class="text_btn"
              @click="deleteColumn"
              type="button"
              >Delete</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Dialog for adding columns -->
    <v-dialog v-model="d_add_column" width="500">
      <v-card>
        <v-form @submit="saveAddColumn">
          <v-card-title class="headline" primary-title
            >Add column to '{{ f_new_column_container_name }}'</v-card-title
          >

          <v-card-text>
            <v-text-field
              v-model="f_new_column_name"
              ref="new_column_name"
              label="Name"
            />
            <v-combobox
              v-model="f_new_column_pattern"
              placeholder="ex. (^[0-9]*$)"
              ref="new_column_pattern"
              chips="true"
              :items="template_patterns"
              label="Pattern"
            >
              <template v-slot:item="{ item }">
                <span>{{ item.text }}&nbsp;</span>
                <span
                  v-if="item.value.length < 20"
                  class="grey--text"
                  style="font-size: 10px;"
                  >{{ item.value }}</span
                >
              </template>
            </v-combobox>
            <v-text-field
              v-model="f_test_value"
              label="Test Value"
              placeholder="Enter a value to test your regex pattern"
              style="margin-top: 10px;"
            />
            <div v-if="f_test_value" style="margin-bottom: 20px;">
              <v-icon :color="isRegexValid ? 'success' : 'error'" small>
                {{ isRegexValid ? 'check_circle' : 'cancel' }}
              </v-icon>
              <span :class="isRegexValid ? 'success--text' : 'error--text'" style="margin-left: 5px; font-size: 13px;">
                {{ isRegexValid ? 'Matches pattern!' : 'Does not match pattern.' }}
              </span>
            </div>
            <v-switch
              v-model="f_new_column_required"
              label="Required"
            ></v-switch>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              class="text_btn"
              type="submit"
              :loading="l_edit_save"
              >Save</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Dialog for adding containers -->
    <v-dialog v-model="d_add_container" width="500">
      <v-card>
        <v-form @submit="saveAddContainer">
          <v-card-title class="headline" primary-title
            >Add container</v-card-title
          >

          <v-card-text>
            <v-text-field
              v-model="f_new_container_name"
              ref="new_container_name"
              label="Name"
            />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              class="text_btn"
              type="submit"
              :loading="l_edit_save"
              >Save</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Dialog for editing containers -->
    <v-dialog v-model="d_edit_container" width="500">
      <v-card>
        <v-form @submit="saveEditContainer">
          <v-card-title class="headline" primary-title
            >Container properties</v-card-title
          >

          <v-card-text>
            <v-text-field
              v-model="f_edit_container_name"
              ref="edit_container_name"
              label="Name"
            />
            <v-switch
              v-model="f_edit_container_exportable"
              label="Exportable"
            ></v-switch>
            <p>
              If you activate this function, then the users are able to export
              this container. By default, all containers are activated to meet
              the DSGVO guidelines.
            </p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              text
              class="text_btn"
              @click="d_delete_container = true"
              type="button"
              :loading="l_edit_save"
              >Delete</v-btn
            >
            <v-btn
              color="primary"
              text
              class="text_btn"
              type="submit"
              :loading="l_edit_save"
              >Save</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Dialog for editing columns -->
    <v-dialog v-model="d_edit_column" width="500">
      <v-card>
        <v-form @submit="saveEditColumn">
          <v-card-title class="headline" primary-title
            >Column properties</v-card-title
          >

          <v-card-text>
            <v-text-field
              v-model="f_edit_column_name"
              ref="edit_column_name"
              label="Name"
            />
            <v-combobox
              v-model="f_edit_column_pattern"
              placeholder="ex. (^[0-9]*$)"
              ref="edit_column_pattern"
              chips="true"
              :items="template_patterns"
              label="Pattern"
            >
              <template v-slot:item="{ item }">
                <span>{{ item.text }}&nbsp;</span>
                <span
                  v-if="item.value.length < 20"
                  class="grey--text"
                  style="font-size: 10px;"
                  >{{ item.value }}</span
                >
              </template>
            </v-combobox>
            <v-text-field
              v-model="f_test_value"
              label="Test Value"
              placeholder="Enter a value to test your regex pattern"
              style="margin-top: 10px;"
            />
            <div v-if="f_test_value" style="margin-bottom: 20px;">
              <v-icon :color="isRegexValid ? 'success' : 'error'" small>
                {{ isRegexValid ? 'check_circle' : 'cancel' }}
              </v-icon>
              <span :class="isRegexValid ? 'success--text' : 'error--text'" style="margin-left: 5px; font-size: 13px;">
                {{ isRegexValid ? 'Matches pattern!' : 'Does not match pattern.' }}
              </span>
            </div>
            <v-switch
              v-model="f_edit_column_required"
              label="Required"
            ></v-switch>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              text
              class="text_btn"
              @click="d_delete_column = true"
              type="button"
              >Delete</v-btn
            >
            <v-btn
              color="primary"
              text
              class="text_btn"
              type="submit"
              :loading="l_edit_save"
              >Save</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { Buckets } from "../logic/Buckets";
import { Projects } from "../logic/Projects";
import { Notifications } from "../notification";

import { Containers } from "../logic/Containers";
import { Columns } from "../logic/Columns";
import { Insights } from "../logic/Insights";

import templates from "../logic/TemplatePatterns";

export default {
  name: "BucketDetail",
  data() {
    return {
      //Content
      p_name: "...",
      b_id: 0,
      b_name: "...",
      b_containers: [],
      insights: [],

      template_patterns: templates,

      //Form
      f_name: "", //Bucket name

      f_new_column_container: -1,
      f_new_column_container_name: "",
      f_new_column_name: "",
      f_new_column_pattern: "",
      f_new_column_required: false,

      f_new_container_name: "",

      f_edit_container_id: -1,
      f_edit_container_name: "",
      f_edit_container_exportable: true,

      f_edit_column_container: -1,
      f_edit_column_id: -1,
      f_edit_column_name: "",
      f_edit_column_pattern: "",
      f_edit_column_required: false,
      f_test_value: "",

      //Loading states
      l_edit_save: false,
      l_treeview_finished: false,
      l_insights: false,

      //Dialogs
      d_edit: false,
      d_delete: false,
      d_add_column: false,
      d_add_container: false,
      d_edit_container: false,
      d_edit_column: false,
      d_delete_container: false,
      d_delete_column: false,
    };
  },
  computed: {
    isRegexValid() {
      try {
        let activePattern = this.d_add_column ? this.f_new_column_pattern : this.f_edit_column_pattern;
        let patternString = activePattern instanceof Object ? activePattern.value : activePattern;
        if (!patternString) return true;
        
        let cleanPattern = patternString;
        if (patternString.startsWith('/') && patternString.lastIndexOf('/') > 0) {
          cleanPattern = patternString.substring(1, patternString.lastIndexOf('/'));
        }
        
        let regex = new RegExp(cleanPattern);
        return regex.test(this.f_test_value);
      } catch (e) {
        return false;
      }
    }
  },
  mounted() {
    var project_id = parseInt(this.$route.params.project_id);
    var bucket_id = parseInt(this.$route.params.id);

    this.b_id = bucket_id;

    var global_this = this;

    this.loadProjectMeta(project_id);
    this.loadBucketMeta(project_id, bucket_id).then(function () {
      global_this.f_name = global_this.b_name;

      global_this.setTitle("Bucket: " + global_this.b_name);

      global_this.loadContainers(bucket_id);
      global_this.loadInsights(project_id);
    });
  },
  methods: {
    goToDataExplorer() {
      this.$router.push(
        "/project/" +
          this.$route.params.project_id +
          "/bucket/" +
          this.$route.params.id +
          "/explorer"
      );
    },
    async loadBucketMeta(project_id, bucket_id) {
      var bucket = await Buckets.get(project_id, bucket_id);
      if (bucket.status === 200) {
        this.b_name = bucket.body.name;
      } else if (bucket.status === 404) {
        Notifications.show("This bucket does not exist.");
        this.$router.replace("/project/" + project_id);
      } else if (bucket.status === 403) {
        Notifications.show("You are not permitted to view in this project.");
        this.$router.replace("/dashboard");
      }
    },
    async loadProjectMeta(project_id) {
      var project_response = await Projects.get(project_id);
      if (project_response.status === 200) {
        if (Array.isArray(project_response.body) && project_response.body.length > 0) {
          this.p_name = project_response.body[0].name;
        } else if (project_response.body && project_response.body.name) {
          this.p_name = project_response.body.name;
        }
      }
    },
    async loadInsights(project_id) {
      var response = await Insights.loadStorageInsights(project_id);
      if (response.status === 200) {
        this.insights = response.body;
      }
      this.l_insights = true;
    },
    formatBytes(bytes) {
      if (!bytes || isNaN(bytes) || bytes == 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      let parsed = parseFloat((bytes / Math.pow(k, i)).toFixed(2));
      if (isNaN(parsed)) return '0 Bytes';
      return parsed + ' ' + sizes[i];
    },
    getContainerInsights(container_id) {
      if (!this.l_insights) return null;
      if (!this.insights || this.insights.length === 0) return {datasets: 0, rows: 0, bytes: 0};
      let c_insights = this.insights.find(i => i.container_id == container_id);
      if (!c_insights) return {datasets: 0, rows: 0, bytes: 0};
      return {
          datasets: Number(c_insights.total_datasets) || 0,
          rows: Number(c_insights.total_rows) || 0,
          bytes: Number(c_insights.total_storage_bytes) || 0
      };
    },
    translatePattern(pattern) {
      if (!pattern || pattern === "/(.*)/" || pattern === "(.*)") return { text: "Any text", translated: true };
      let normalizedPattern = pattern.replace(/\\\\/g, "\\");
      let template = this.template_patterns.find(t => t.value === pattern || t.value === normalizedPattern);
      if (template) return { text: template.text, translated: true };
      return { text: pattern, translated: false };
    },
    getBucketTotalInsights() {
      if (!this.l_insights) return {containers: 0, datasets: 0, rows: 0, bytes: 0};
      let b_insights = this.insights.filter(i => i.bucket_id == this.b_id);
      let total_containers = b_insights.filter(i => i.container_id != null).length;
      let total_datasets = 0;
      let total_rows = 0;
      let total_bytes = 0;
      b_insights.forEach(i => {
          total_datasets += Number(i.total_datasets) || 0;
          total_rows += Number(i.total_rows) || 0;
          total_bytes += Number(i.total_storage_bytes) || 0;
      });
      return {
          containers: total_containers,
          datasets: total_datasets,
          rows: total_rows,
          bytes: total_bytes
      };
    },
    async loadContainers(bucket_id) {
      var global_this = this;

      var response = await Containers.load(bucket_id);
      if (response.status === 200) {
        global_this.b_containers = [];
        var containers = response.body;

        if (containers.length === 0) {
          this.l_treeview_finished = true;
        } else {
          containers.forEach(async function (curr) {
            //Load columns per container
            var r_columns = await Columns.load(curr.id);
            var children = [];
            if (r_columns.status === 200) {
              r_columns.body.forEach(function (curr_col) {
                children.push({
                  id: parseInt(curr_col.id),
                  name: curr_col.name,
                  pattern: curr_col.pattern,
                  required: Number(curr_col.required) === 1,
                });
              });
            }

            //Push containers
            global_this.b_containers.push({
              id: parseInt(curr.id),
              name: curr.name,
              exportable: curr.exportable === "1",
              children: children,
            });

            if (global_this.b_containers.length === containers.length) {
              global_this.b_containers.sort((a, b) => a.name.localeCompare(b.name));
              global_this.l_treeview_finished = true;
            }
          });
        }
      } else {
        this.l_treeview_finished = true;
      }
    },
    back() {
      this.$router.go(-1);
    },
    saveEdit(e) {
      e.preventDefault();

      var global_this = this;

      var bucket_id = parseInt(this.$route.params.id);
      this.f_name = this.f_name.trim();

      this.l_edit_save = true;

      Buckets.edit(bucket_id, this.f_name).then(function (response) {
        global_this.l_edit_save = false;
        if (response.status === 200) {
          Notifications.show(response.message);
          global_this.d_edit = false;
          global_this.b_name = global_this.f_name;
        } else {
          Notifications.show(response.message);
        }
      });
    },
    deleteBucket() {
      var global_this = this;

      var project_id = parseInt(this.$route.params.project_id);
      var bucket_id = parseInt(this.$route.params.id);
      Buckets.delete(bucket_id).then(function (response) {
        if (response.status === 200) {
          Notifications.show(response.message);
          global_this.$router.replace("/project/" + project_id);
        } else {
          Notifications.show(response.message);
        }
      });
    },
    async saveAddColumn(e) {
      e.preventDefault();
      this.l_edit_save = true;

      var response = await Columns.add(
        this.f_new_column_container,
        this.f_new_column_name,
        this.f_new_column_pattern instanceof Object
          ? this.f_new_column_pattern.value
          : this.f_new_column_pattern,
        this.f_new_column_required
      );
      if (response.status === 200) {
        Notifications.show(response.message);
        this.d_add_column = false;
        this.f_new_column_name = "";
        this.f_new_column_pattern = "";
        this.f_new_column_required = false;
        this.reloadContainerColumns(this.f_new_column_container);
      } else {
        Notifications.show(response.message);
      }
      this.l_edit_save = false;
    },
    async saveAddContainer(e) {
      e.preventDefault();
      var bucket_id = parseInt(this.$route.params.id);
      this.l_edit_save = true;

      var response = await Containers.add(bucket_id, this.f_new_container_name);
      if (response.status === 200) {
        Notifications.show(response.message);
        this.f_new_container_name = "";
        this.d_add_container = false;
        this.loadContainers(bucket_id);
      } else {
        Notifications.show(response.message);
      }
      this.l_edit_save = false;
    },
    openColumn(container, item) {
      this.d_edit_column = true;
      this.f_edit_column_container = container.id;
      this.f_edit_column_id = item.id;
      this.f_edit_column_name = item.name;
      this.f_edit_column_pattern = item.pattern;
      this.f_edit_column_required = item.required;
      this.f_test_value = "";
    },
    openContainer(item) {
      this.d_edit_container = true;
      this.f_edit_container_id = item.id;
      this.f_edit_container_name = item.name;
      this.f_edit_container_exportable = item.exportable;
    },
    async saveEditContainer(e) {
      e.preventDefault();
      var bucket_id = parseInt(this.$route.params.id); //For reloading containers
      this.l_edit_save = true;

      var response = await Containers.edit(
        this.f_edit_container_id,
        this.f_edit_container_name,
        this.f_edit_container_exportable
      );
      if (response.status === 200) {
        Notifications.show(response.message);
        this.f_edit_container_name = "";
        this.d_edit_container = false;
        this.loadContainers(bucket_id);
      } else {
        Notifications.show(response.message);
      }
      this.l_edit_save = false;
    },
    async deleteContainer() {
      var container_id = this.f_edit_container_id;
      var bucket_id = parseInt(this.$route.params.id); //For reloading containers

      var result = await Containers.delete(container_id);
      if (result.status === 200) {
        Notifications.show(result.message);
        this.d_delete_container = false;
        this.d_edit_container = false;
        this.loadContainers(bucket_id);
      } else {
        Notifications.show(result.message);
      }
    },
    async deleteColumn() {
      var column_id = this.f_edit_column_id;

      var result = await Columns.delete(column_id);
      if (result.status === 200) {
        Notifications.show(result.message);
        this.d_delete_column = false;
        this.d_edit_column = false;
        this.reloadContainerColumns(this.f_edit_column_container);
      } else {
        Notifications.show(result.message);
      }
    },
    async saveEditColumn(e) {
      e.preventDefault();
      this.l_edit_save = true;

      var response = await Columns.edit(
        this.f_edit_column_id,
        this.f_edit_column_name,
        this.f_edit_column_pattern instanceof Object
          ? this.f_edit_column_pattern.value
          : this.f_edit_column_pattern,
        this.f_edit_column_required
      );
      if (response.status === 200) {
        Notifications.show(response.message);
        this.f_edit_column_name = "";
        this.l_edit_save = false;
        this.d_edit_column = false;
        this.reloadContainerColumns(this.f_edit_column_container);
      } else {
        Notifications.show(response.message);
        this.l_edit_save = false;
      }
    },
    async reloadContainerColumns(container_id) {
      var r_columns = await Columns.load(container_id);
      if (r_columns.status === 200) {
        var children = [];
        r_columns.body.forEach(function (curr_col) {
          children.push({
            id: parseInt(curr_col.id),
            name: curr_col.name,
            pattern: curr_col.pattern,
            required: Number(curr_col.required) === 1,
          });
        });
        
        let container = this.b_containers.find(c => c.id === container_id);
        if (container) {
          // This updates the local variable reactively without replacing the whole array
          // Since the array index of container doesn't change, v-expansion-panels doesn't close!
          container.children = children;
        }
      }
    },
  },
  watch: {
    f_edit_column_pattern(val) {
      if (val instanceof Object && val.example) {
        this.f_test_value = val.example;
      }
    },
    f_new_column_pattern(val) {
      if (val instanceof Object && val.example) {
        this.f_test_value = val.example;
      }
    },
    d_add_column(curr) {
      var global_this = this;
      if (curr) {
        setTimeout(function () {
          global_this.$refs.new_column_name.focus();
        }, 200);
      }
    },
    d_add_container(curr) {
      var global_this = this;
      if (curr) {
        setTimeout(function () {
          global_this.$refs.new_container_name.focus();
        }, 200);
      }
    },
  },
};
</script>
